import { TFunction } from 'i18next';
import { GridEnrichedColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { NoteCell } from './component';
import { ReceiptsCellViewModel } from '../viewModel';
import { ReceiptsRowViewModel } from '../../row/viewModel';

export class NoteCellViewModel extends ReceiptsCellViewModel {
  constructor(row: ReceiptsRowViewModel) {
    super(row);
  }

  onClick(event: React.MouseEvent<HTMLElement>) {
    this.row.table.noteOverlay.open(this.receipt, event.currentTarget);
  }

  get disabled() {
    return !this.receipt.note;
  }

  get value() {
    return this.receipt.note;
  }

  static buildColDef(t: TFunction): GridEnrichedColDef {
    return {
      field: 'note',
      headerName: t('common:NOTE'),
      description: t('employee:NOTE_COLUMN_INFO'),
      width: 70,
      sortable: false,
      filterable: true,
      renderCell: (params: GridRenderCellParams<NoteCellViewModel>) => <NoteCell {...params} />
    };
  }
}
